/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

const settlementsMainPageConfiguration: {
    titleCustomer: string;
    titleSupplier: string;
    animationTimeout: number;
    fullLineTooltipDetail: string;
    exportFileNameCustomer: string;
    exportFileNameSupplier: string;
    exportWorksheetTitleCustomer: string;
    exportWorksheetTitleSupplier: string;
} = {
    titleCustomer: ' CUSTOMER COMPLAINT SETTLEMENTS',
    titleSupplier: 'SUPPLIER COMPLAINT SETTLEMENTS',
    animationTimeout: 4800,
    fullLineTooltipDetail: 'settlement line',
    exportFileNameSupplier: 'orcan-settlements-report.xlsx',
    exportFileNameCustomer: 'orcan-customer-settlements-report.xlsx',
    exportWorksheetTitleSupplier: 'Settlements Report',
    exportWorksheetTitleCustomer: 'Customer Settlements Report'
};

export default settlementsMainPageConfiguration;
